<template>
  <div class="groups">
    <div v-for="g in rows" :key="g.group" class="group-row">
      <div class="row-head">
        <span class="g-name">{{ g.group }} <span class="g-meta">{{ g.headcount }} · {{ g.fte }} FTE</span></span>
        <span class="g-val">{{ fmtM(g.cost) }} <span class="g-share">{{ g.share }}</span></span>
      </div>
      <div class="track">
        <div class="bar bar-new" :style="{ width: pct(g.cost) }"></div>
      </div>
      <div class="track track-old">
        <div class="bar bar-old" :style="{ width: pct(g.base2026) }"></div>
      </div>
      <div class="row-sub">
        {{ fmtM(g.base2026) }} full-year on 2026 scales →
        <span class="delta" :class="{ 'delta-hot': g.deltaPct >= 25 }">
          {{ g.deltaPct >= 0 ? '+' : '' }}{{ g.deltaPct.toFixed(1) }}%
        </span>
        <span v-if="g.note" class="g-note">· {{ g.note }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatM } from '../../utils/boardEngine';

export default {
  name: 'GroupBars',
  // rows: [{ group, headcount, fte, cost, base2026, deltaPct, share, note? }]
  props: { rows: { type: Array, required: true } },
  computed: {
    max() { return Math.max(...this.rows.map((g) => Math.max(g.cost, g.base2026))); },
  },
  methods: {
    fmtM: formatM,
    pct(v) { return `${Math.max(0.5, (v / this.max) * 100)}%`; },
  },
};
</script>

<style scoped>
.group-row { margin-bottom: 18px; }
.row-head { display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 5px; gap: 10px; }
.g-name { font-size: 13.5px; font-weight: 700; color: var(--ink); }
.g-meta { font-weight: 400; color: var(--muted); font-size: 12px; }
.g-val { font-size: 13.5px; font-weight: 700; color: var(--ink); font-variant-numeric: tabular-nums; white-space: nowrap; }
.g-share { font-weight: 400; color: var(--muted); font-size: 12px; }
.track { background: var(--track); height: 10px; width: 100%; }
.track-old { height: 5px; margin-top: 2px; }
.bar { height: 100%; }
.bar-new { background: var(--ink); }
.bar-old { background: var(--muted); }
.row-sub { font-size: 11px; color: var(--muted); margin-top: 4px; font-variant-numeric: tabular-nums; }
.delta { font-weight: 700; color: var(--ink); }
.delta-hot { color: var(--red); }
.g-note { color: var(--muted); }
</style>
